// extracted by mini-css-extract-plugin
export default {"leftNavigarion":"CarouselLeft_leftNavigarion__bSLSk"};